import apiClient from './axios';
import type {
  ApiResponse,
  LoginRequest,
  RegisterRequest,
  AuthResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
} from '@shared/types/api.types';
import type { User } from '@shared/types/user.types';

/**
 * 이메일 중복 체크
 */
export async function checkEmail(email: string): Promise<boolean> {
  const response = await apiClient.get<ApiResponse<{ available: boolean }>>('/auth/check-email', {
    params: { email },
  });
  return response.data.data!.available;
}

/**
 * 회원가입
 */
export async function register(data: RegisterRequest): Promise<AuthResponse> {
  const response = await apiClient.post<ApiResponse<AuthResponse>>('/auth/register', data);
  return response.data.data!;
}

/**
 * 로그인
 */
export async function login(data: LoginRequest): Promise<AuthResponse> {
  const response = await apiClient.post<ApiResponse<AuthResponse>>('/auth/login', data);
  return response.data.data!;
}

/**
 * 로그아웃
 */
export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

/**
 * 토큰 갱신
 */
export async function refreshToken(data: RefreshTokenRequest): Promise<RefreshTokenResponse> {
  const response = await apiClient.post<ApiResponse<RefreshTokenResponse>>('/auth/refresh', data);
  return response.data.data!;
}

/**
 * 현재 사용자 정보 조회
 */
export async function getMe(): Promise<User> {
  const response = await apiClient.get<ApiResponse<User>>('/auth/me');
  return response.data.data!;
}

/**
 * 아이디 찾기 (사용자명 + 생년월일로)
 */
export async function findUsername(data: { username: string; birthdate: string }): Promise<void> {
  await apiClient.post<ApiResponse<{ message: string }>>('/auth/find-username', {
    username: data.username,
    birthdate: data.birthdate,
  });
}

/**
 * 비밀번호 재설정 요청 (이메일로 링크 발송)
 */
export async function requestPasswordReset(email: string): Promise<void> {
  await apiClient.post<ApiResponse<{ message: string }>>('/auth/reset-password-request', {
    email,
  });
}

/**
 * 비밀번호 재설정 (토큰으로)
 */
export async function resetPassword(token: string, password: string): Promise<void> {
  await apiClient.post<ApiResponse<{ message: string }>>('/auth/reset-password', {
    token,
    password,
  });
}